<template>
  <v-container
    id="call-log-customer-details"
    class="px-5 pt-0"
    v-if="customer">
    <h3 class="mb-3">Customer Details</h3>

    <CustomerDetails :customer="customer" />

    <!-- Edit Customer -->
    <v-row>
      <v-col>
        <v-btn
          type="button"
          color="success"
          outlined
          block
          @click="$store.dispatch(
            'openCustomerModalForm',
            {
              customer: {
                CustomerID: customer.CustomerID,
              },
            },
          )">
          Edit Customer
        </v-btn>
      </v-col>
    </v-row>
    <!-- / Edit Customer -->
  </v-container>
</template>

<script>
import CustomerDetails from './CustomerDetails.vue';

export default {
  name: 'CallLogCustomerDetails',
  props: [
    'customer',
  ],
  components: {
    CustomerDetails,
  },
};
</script>

<style lang="scss"></style>
